import React from 'react';
import { clampSingleImageAspectRatio } from './chatImageGroupUtils';
import '../../../../css/common/chat/ChatImageGroupBubble.css';

const noop = () => {};

export default function ChatImageGroupBubble({
  items = [],
  onOpen = noop,
  unavailableText = '画像を表示できません。',
}) {
  const safeItems = Array.isArray(items) ? items.filter(Boolean).slice(0, 5) : [];
  if (!safeItems.length) {
    return (
      <span className="image-expired chat-message-content__expired chat-message-content__expired--stable">
        <i className="fa-solid fa-image" aria-hidden="true"></i>
        <span className="chat-message-content__expiredText">{unavailableText}</span>
      </span>
    );
  }

  const count = safeItems.length;
  const isSingle = count === 1;
  const gridClass = `chat-image-group chat-image-group--count-${count}${isSingle ? ' chat-image-group--single' : ''}`;

  return (
    <div
      className={gridClass}
      style={
        isSingle
          ? { '--chat-image-single-aspect': clampSingleImageAspectRatio(safeItems[0]?.width, safeItems[0]?.height) }
          : undefined
      }
    >
      {safeItems.map((item, index) => {
        const hasImage = Boolean(item?.src);
        return (
          <button
            key={item?.messageId || item?.imageId || item?.src || index}
            type="button"
            className={`chat-image-group__cell${index === 0 && (count === 3 || count === 5) ? ' chat-image-group__cell--feature' : ''}`}
            onClick={hasImage ? () => onOpen(item, index) : undefined}
            disabled={!hasImage}
            aria-label={`画像${index + 1}を開く`}
          >
            {hasImage ? (
              <img className="chat-image-group__image" src={item.src} alt="メッセージ画像" loading="lazy" />
            ) : (
              <span className="chat-image-group__empty">
                <i className="fa-solid fa-image" aria-hidden="true" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
